import React, { useContext } from 'react';
import Header from '../../components/Header';
import Spinner from '../../components/Spinner';
import BackgroundImage from '../../components/BackgroundImage';
import Content from '../../elements/Content';
import useFetch from '../../hooks/useFetch';
import './style.scss';
import { Navigate, useParams } from 'react-router-dom';
import { StaticContentContext } from '../../Layout';

function Page() {
  const {slug} = useParams();
  const { notFoundEndpoint } = useContext(StaticContentContext);
  const [contentArray, loading] = useFetch("/pages?acf_format=standard&slug=" + slug, []);
  const content = contentArray[0];
  const elements = content?.acf.elements;

  if (!loading && !content) {
    return <Navigate to={notFoundEndpoint} />;
  }
  
  return loading ? (
    <div className="Page">
      <Spinner size="xlarge" centered />
    </div>
  ) : (
    <>
      <Header content={content} />
      <BackgroundImage className="Page" content={content?.acf}>
        <div className="Page__content">
          {elements?.length > 0 && <Content elements={elements} />}
        </div>
      </BackgroundImage>
    </>
  );
}

export default Page;
